import { AuroraBackground } from "./components/AuroraBackground";
import { Hero } from "./components/Hero";
import { TechStack } from "./components/TechStack";
import { Experience } from "./components/Experience";
import { ProjectsDisplayer } from "./ProjectsDisplayer";
import { FlashbangIcon } from "./components/everything/FlashbangIcon";
import { useAppTheme } from "./hooks/useAppTheme";

export function Home() {
  const { theme, toggle } = useAppTheme();
  const isDark = theme === "dark";

  return (
    <div className="relative flex flex-col min-h-screen">
      <AuroraBackground theme={theme} />
      <button
        type="button"
        onClick={toggle}
        className="fixed top-4 right-4 z-30 inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-all"
        aria-label={isDark ? "Modo claro" : "Modo oscuro"}
        title={isDark ? "Modo claro" : "Modo oscuro"}
      >
        <FlashbangIcon className="w-5 h-5" />
      </button>
      <Hero />
      <TechStack />
      <Experience />
      <ProjectsDisplayer />
    </div>
  );
}
